import React from 'react';
import { Skeleton, Divider } from 'antd-v5';

const QuickViewSkeletonCard = ({ hasFooter = false }) => {
  return (
    <div className="quick-view-card" style={{ borderLeftColor: '#f0f0f0' }}>
      <div className="flex-row items-center justify-between w-100-P">
        <div className="flex-col-left" style={{ width: '60%' }}>
          <Skeleton.Input active size="small" style={{ width: '100%', marginBottom: '8px' }} />
          <Skeleton.Input active size="small" style={{ width: '80%' }} />
        </div>
        <div className="flex-col-right gap-16">
          <Skeleton.Input active size="small" style={{ width: '60px' }} />
        </div>
      </div>
      {hasFooter && (
        <>
          <Divider orientation="center" style={{ margin: '8px 0' }} />
          <div className="flex-row items-center justify-between">
            <Skeleton.Button active size="small" style={{ width: '80px' }} />
            <Skeleton.Button active size="small" style={{ width: '100px' }} />
          </div>
        </>
      )}
    </div>
  );
};

export default QuickViewSkeletonCard;
